<style scoped>
    button {
        width: 220px;
        height: 60px;
        background: #91DC60;
        border-radius: 8px;

        font-weight: 700;
        font-size: 20px;
        line-height: 27px;
        color: #FFFFFF;
    }

    .personal_data {
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;

        color: #525252;
    }
</style>

<template>
    <v-row align="center">
        <Field anketaName="codeSMS"/>
        <v-col cols="6" class="text-right mt-10">
            <Button 
                @click="isNotSended ? send() : check()"
                :loading="isLoading"
                >
                {{ isNotSended ? 'Запросить' : 'Проверить' }} код
            </Button>
        </v-col>
        <v-col cols="12" class="personal_data">
            Подтвердите свое <a href="/docs/consent_processing_personal_data.pdf" target="_blank">согласие</a> на обработку персональных данных, введя код из смс
        </v-col>
    </v-row>
</template>

<script>
export default {
    data: () => ({
        isNotSended: true,
        isLoading: false,
    }),
    methods: {
        send() {
            this.isLoading = true;

            this.$connector.SendSmsConsent().then( data => {
                this.isLoading = false;

                if (data.isSuccess) {
                    this.isNotSended = false;
                    this.$anketa.codeSMS.disabled = false;
                }
            });
        },
        check() {
            this.$connector.CheckSmsConsent().then( data => {
                if (data.isSuccess && data.checkCode) {
                    this.$emit('success');
                }
            })
        }
    }
}
</script>